
















































































































import { mapActions, mapState } from 'vuex';
import Accordion from '@/components/Accordion.vue';
import ChromeEditorPanel from '@/components/chrome/EditorPanel.vue';
import FieldBase from '@/components/field/Base.vue';
import PillContent from '@/components/pill/PillContent.vue';
import PropsTableMini from '@/components/PropsTableMini.vue';
import VendorResource from '@/features/vendor/views/vendor/VendorResource.vue';

import store from './store';

export default {
  props: {
    value: Array,
    resourceId: String,
    resourceType: String,
  },
  created() {
    if (!this.$store.state.vendorPanel) {
      this.$storeRegister('vendorPanel', store);
    }

    // update list of vendors
    this.loadVendors();
    this.updateResourceVendors(this.value);
  },
  computed: {
    ...mapState('vendorPanel', [
      'allVendors',
      'resourceVendors',
    ]),
    localResourceVendors: {
      get() {
        return this.resourceVendors;
      },
      set(value: any) {
        this.updateResourceVendors(value);
        this.$emit('input', value);
      },
    },
    vendorList() {
      return this
        .allVendors
        .reduce((allKeys: any, current: any) => {
          allKeys[current.id] = current.name;
          return allKeys;
        }, {});
    },
  },
  watch: {
    value() {
      // vendor resources change when going between pages
      this.updateResourceVendors(this.value);
    },
  },
  methods: {
    ...mapActions('vendorPanel', [
      'addVendorToResource',
      'createVendor',
      'loadVendors',
      'updateResourceVendors',
    ]),
    addVendor(timeout = 100) {
      this.addVendorToResource();
      this.$emit('input', this.resourceVendors);
      this.selectLastRowDropdown(timeout);
    },
    createVendorDialog() {
      const self = this;
      this.$store.commit('dialog/CREATE', {
        compact: true,
        component: {
          mounted() {
            // remove focus from dialog buttons
            setTimeout(() => {
              this.$el.querySelector('input').focus();
            }, 100);
          },
          data: () => ({
            message: '',
            vendorName: '',
          }),
          methods: {
            create() {
              if (!this.vendorName.trim()) {
                this.message = 'Please enter a vendor name';
                this.$el.querySelector('input').focus();
                return;
              }

              this.$store.commit('loader/ADD', {
                title: 'Creating vendor',
                promise: self
                  .createVendor({
                    name: this.vendorName,
                    resourceId: self.resourceId,
                    resourceType: self.resourceType,
                  })
                  .then((vendor: any) => {
                    // close dialog (assuming this is the only one open)
                    const { dialogs, REMOVE } = this.$parent;
                    REMOVE(dialogs[0].id);
                  }),
              });
            },
          },
          template: `
            <div style="width: 260px; padding: 0;">
              <div>
                <input
                  v-model="vendorName"
                  @keyup="message = ''"
                  @keyup.enter="create"
                  placeholder="Vendor name"
                  aria-label="Vendor name" />
              </div>
              <transition name="transition fade-down">
                <p class="error" v-if="message">{{ message }}</p>
              </transition>
            </div>
          `,
        } as IView,
        buttons: [
          {
            text: 'Create vendor',
            click: (dialog: any) => dialog.component[0].create(),
          },
          {
            text: 'Close',
            click: (dialog: any) => dialog.close(),
          },
        ],
      });
    },
    removeVendor(index: number) {
      // update local reference which updates local store
      // and emits to the parent component model
      this.localResourceVendors = [
        ...this.value.slice(0, index),
        ...this.value.slice(index + 1),
      ];
    },
    selectLastRowDropdown(timeout: number) {
      // a little long winded just incase timer is too fast for device processor
      setTimeout(() => {
        // display last accordion item
        const lastIndex = this.localResourceVendors.length - 1;
        this.$refs.accordion.toggle(lastIndex);

        // click on change vendor button
        this.$nextTick(() => {
          const { changeVendor } = this.$refs;
          changeVendor && changeVendor.click();
        });
      }, timeout);
    },
  },
  components: {
    Accordion,
    ChromeEditorPanel,
    FieldBase,
    PillContent,
    PropsTableMini,
    VendorResource,
  },
} as IView;
